import { render, staticRenderFns } from "./ProfessorExpansionItem.vue?vue&type=template&id=40eb44a7&scoped=true"
import script from "./ProfessorExpansionItem.vue?vue&type=script&lang=js"
export * from "./ProfessorExpansionItem.vue?vue&type=script&lang=js"
import style0 from "./ProfessorExpansionItem.vue?vue&type=style&index=0&id=40eb44a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40eb44a7",
  null
  
)

export default component.exports